import camelcaseKeys from "camelcase-keys";
import {
  onGetVoiceSettingDetail,
  onUpdateServiceVoiceSetting,
} from "services/apis/voiceSetting";

const {
  createSlice,
  createAsyncThunk,
  createSelector,
} = require("@reduxjs/toolkit");

export const doUpdateServiceVoiceSetting = createAsyncThunk(
  "voiceSetting/doUpdateServiceVoiceSetting",
  async params => {
    const result = await onUpdateServiceVoiceSetting(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

export const doGetVoiceSettingDetail = createAsyncThunk(
  "voiceSetting/doGetVoiceSettingDetail",
  async params => {
    const result = await onGetVoiceSettingDetail(params);
    if (!result) {
      return;
    }
    return camelcaseKeys(result);
  }
);

const initialState = {
  isSaving: false,
  voiceSettingDetail: null,
};

const slice = createSlice({
  name: "voiceSetting",
  initialState: initialState,
  reducers: {
    setVoiceSettingDetail: (state, action) => {
      state.voiceSettingDetail = action.payload;
    },
  },
  extraReducers: {
    [doGetVoiceSettingDetail.fulfilled]: (state, action) => {
      state.voiceSettingDetail = action.payload;
    },
  },
});

const { reducer, actions } = slice;
export const { setVoiceSettingDetail } = actions;
export default reducer;

export const getVoiceSettingDetail = createSelector(
  state => state.voiceSetting.voiceSettingDetail,
  voiceSettingDetail => voiceSettingDetail
);
